<span
  class="status badge"
  [class.badge-orange]="[globals.STATUS_ASSIGNMENT_CANCELLED].includes(statusId)"
  [class.badge-yellow]="[globals.STATUS_ASSIGNMENT_IN_PROGRESS].includes(statusId)"
  [class.badge-green]="[globals.STATUS_ASSIGNMENT_COMPLETED].includes(statusId)"
  [class.badge-grey]="[globals.STATUS_ASSIGNMENT_ARCHIVED].includes(statusId)"
  [class.badge-red]="[globals.STATUS_ASSIGNMENT_DELETED].includes(statusId)"
  [class.badge-blue]="[globals.STATUS_ASSIGNMENT_AUDIT_REQUESTED].includes(statusId)"
  [class.badge-green-dark]="[globals.STATUS_ASSIGNMENT_APPROVED].includes(statusId)"
  [class.badge-pink]="[globals.STATUS_ASSIGNMENT_REJECTED].includes(statusId)">
  {{ statusId | resourceById | async }}
</span>
